import { connect } from "react-redux";
import { bindActionCreators } from "redux";
// import mixpanel from "mixpanel-browser";

const Services = (props) => {
  // mixpanel.init("b252d85eb9a02bea2baee2479d1a00d6");
  
  return null;
};
const mapStateToProps = (state) => ({
  userInfo: state.auth.login.userinfo,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({}, dispatch),
});

const connectedServices = connect(
  mapStateToProps,
  mapDispatchToProps
)(Services);
export default connectedServices;
